<template>
  <div class="col-12 p-0">
    <nprogress-container style="height: 3px !important; z-index: 9999;"></nprogress-container>
    <div class="card">
      <div class="card-header">
        <h4 class="text-center">SBU PRODUCT STATUS {{today.format('DD MMMM YYYY').toUpperCase()}}</h4>
      </div>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th>Code Product</th>
              <th width="250px">Nama Product</th>
              <th>Harga Principal</th>
              <th>Harga Retail</th>
              <th>Harga Reseller</th>
              <th>Harga Dropship</th>
              <th>Stock</th>
              <th>Unit</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.code">
              <td>{{product.code.toUpperCase()}}</td>
              <td>{{product.name.toUpperCase()}}</td>
              <td>{{formatPrice(product.principal)}}</td>
              <td>
                <span v-if="product.prices && 'RETAIL' in product.prices">{{formatPrice(product.prices['RETAIL'])}}</span>
                <span v-else>0</span>
              </td>
              <td>
                <span v-if="product.prices && 'RESELLER' in product.prices">{{formatPrice(product.prices['RESELLER'])}}</span>
                <span v-else>0</span>
              </td>
              <td>
                <span v-if="product.prices && 'DROPSHIP' in product.prices">{{formatPrice(product.prices['DROPSHIP'])}}</span>
                <span v-else>0</span>
              </td>
              <td>{{formatPrice(product.stock)}}</td>
              <td>{{product.unit}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer" style="font-size: 10px">
        <div class="row" style="margin-top: 10px">
          <div class="col-12">Jakarta {{ today.format('DD/MM/YYYY') }}</div>
          <div class="col-6">
            <p>Dibuat Oleh</p>
            <br/><br/><br/>
            <p>............................................</p>
          </div>
          <div class="col-6 text-right">
            <p>Disetujui Oleh</p>
            <br/><br/><br/>
            <p>............................................</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

export default {
  data () {
    return {
      today: moment(),
      products: [],
      limit: 100,
      offset: 0
    }
  },
  components: {
    NprogressContainer
  },
  created () {
    this.getProducts()
  },
  methods: {
    getProducts () {
      var vm = this
      var baseUri = 'api/sales/products/?limit=' + vm.limit + '&offset=' + vm.offset + '&sort=name-asc'
      vm.axios.get(baseUri)
        .then(
          (response) => {
            console.log(response)
            var data = response.data
            var results = data.results
            for (var i = 0; i < results.length; i++) {
              vm.products.push(results[i])
            }
            vm.offset += vm.limit
            if (data.next) {
              vm.getProducts()
            } else {
              setTimeout(() => {
                window.print()
              }, 1000)
            }
          }
        )
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
</script>

<style scoped>
  table > thead > tr > th, table > tbody > tr > td {
    font-size: 9px !important; 
  }
  table > tbody > tr > td {
    padding: 0px 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/PrintProduct.vue